import * as Scrivito from "scrivito";

Scrivito.provideComponent("NavigationElementWidget", ({ widget }) => (
  <Scrivito.ContentTag content={widget} attribute="headline" />
));
